/* kravaritis.com: σελίδα προϊόντος (επιλογές, πρόσθετα, φωτογραφίες, καλάθι, προτάσεις) */
(function () {
  var root = document.querySelector('[data-krv-product]');
  if (!root) return;
  var dataEl = document.querySelector('[data-krv-product-json]');
  var data = JSON.parse(dataEl.textContent);
  var variants = data.variants;
  var form = root.querySelector('[data-krv-product-form]');
  var idInput = form.querySelector('[data-krv-variant-input]');
  var qtyInput = form.querySelector('[data-krv-qty-input]');
  var addBtn = form.querySelector('[data-krv-add]');
  var errEl = form.querySelector('[data-krv-error]');
  var bar = document.querySelector('[data-krv-bar]');
  var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

  /* ---- τιμές ---- */
  function fmt(cents) {
    var f = data.moneyFormat || '€{{amount_with_comma_separator}}';
    function num(c, dec, ts, ds) {
      var n = (Math.abs(c) / 100).toFixed(dec).split('.');
      var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return whole + (n[1] ? ds + n[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_period_and_space_separator') return num(cents, 2, ' ', '.');
      return num(cents, 2, ',', '.');
    });
  }

  /* ---- επιλογές ---- */
  var optionSets = Array.prototype.slice.call(form.querySelectorAll('[data-krv-option]'));
  function selectedOptions() {
    return optionSets.map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function findVariant(opts) {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
    })[0];
  }
  function refreshChoices() {
    var sel = selectedOptions();
    optionSets.forEach(function (fs, i) {
      fs.querySelectorAll('.krv-choice').forEach(function (label) {
        var input = label.querySelector('input');
        var trial = sel.slice(); trial[i] = input.value;
        var v = findVariant(trial);
        var delta = label.querySelector('[data-krv-delta]');
        label.classList.toggle('is-on', input.checked);
        label.classList.toggle('is-off', !v || !v.available);
        label.classList.toggle('is-none', !v);
        if (delta) {
          if (!v) delta.textContent = 'δεν υπάρχει';
          else if (input.checked || v.price === current.price) delta.textContent = input.checked ? '' : 'ίδια τιμή';
          else delta.textContent = (v.price > current.price ? '+' : '−') + fmt(v.price - current.price);
          if (v && !v.available) delta.textContent = 'μη διαθέσιμο';
        }
      });
    });
  }
  function onOptionChange(e) {
    var fsIndex = optionSets.indexOf(e.target.closest('[data-krv-option]'));
    var sel = selectedOptions();
    var v = findVariant(sel);
    if (!v) {
      /* ο συνδυασμός δεν υπάρχει: κρατάμε την αλλαγή και διαλέγουμε την πρώτη έκδοση που ταιριάζει σε αυτήν */
      var only = sel.map(function (o, i) { return i === fsIndex ? o : null; });
      v = findVariant(only);
      if (v) optionSets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === v.options[i]; });
      });
    }
    if (v) setVariant(v);
  }
  optionSets.forEach(function (fs) { fs.addEventListener('change', onOptionChange); });

  /* ---- πρόσθετα ----
     Κάθε πρόσθετο είναι μια παραλλαγή άλλου προϊόντος. Ομαδοποιούνται με βάση το rules.label
     (π.χ. «Βάση φούρνου»). Μέσα στην ομάδα: μία κάρτα ανά τύπο (1η επιλογή του πρόσθετου)
     και, αν χρειάζεται, μικρά κουμπιά για τη 2η επιλογή (π.χ. Βασική / Με ρόδες).
     Κανόνες (rules): only_when: εμφανίζεται μόνο όταν η επιλογή του προϊόντος περιέχει μία από αυτές τις τιμές
                      hide_when: κρύβεται όλη η ομάδα όταν η επιλογή του προϊόντος περιέχει μία από αυτές
                      match: τιμές (π.χ. MarineLine) που πρέπει να ταιριάζουν και στις δύο πλευρές
                      none_note: τι γράφει όταν τίποτα δεν ταιριάζει (π.χ. φούρνος αερίου)
                      multi: πολλές επιλογές μαζί (checkbox) αντί για μία */
  var addonRoot = form.querySelector('[data-krv-addons-root]');
  var addonItems = [];
  var addonGroups = [];
  var addonState = {}; /* groupIndex -> { cardKey: variantId } για τις επιλεγμένες */
  if (addonRoot) {
    try { addonItems = JSON.parse(form.querySelector('[data-krv-addons-json]').textContent); } catch (e) { addonItems = []; }
    var byLabel = {};
    addonItems.forEach(function (it) {
      var r = it.rules || {};
      var label = r.label || it.product;
      if (!byLabel[label]) { byLabel[label] = { label: label, multi: !!r.multi, note: r.note || '', hideWhen: [], hideNote: '', items: [], cards: [] }; addonGroups.push(byLabel[label]); }
      var g = byLabel[label];
      (r.hide_when || []).forEach(function (h) { if (g.hideWhen.indexOf(h) < 0) g.hideWhen.push(h); });
      if (r.hide_note) g.hideNote = r.hide_note;
      if (r.multi) g.multi = true;
      var vendorRe = new RegExp('^' + (it.vendor || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i');
      it.cardLabel = it.single ? it.product.replace(vendorRe, '') : it.options[0];
      it.subLabel = (!it.single && it.options.length > 1) ? it.options.slice(1).join(' / ') : '';
      it.cardKey = it.productId + '|' + it.cardLabel;
      var card = g.cards.filter(function (c) { return c.key === it.cardKey; })[0];
      if (!card) { card = { key: it.cardKey, label: it.cardLabel, items: [] }; g.cards.push(card); }
      card.items.push(it);
      g.items.push(it);
    });
    /* σειρά βημάτων: πρώτα τοποθέτηση (βάση, πόδια, στοίβαξη), μετά απορροφητήρας, μετά αναλώσιμα */
    var PRI = ['Βάση', 'Πόδια', 'Κιτ', 'Απορροφ', 'Αποσκλ', 'Απορρυπ', 'Πάγκ'];
    function pri(l) { for (var i = 0; i < PRI.length; i++) if (l.indexOf(PRI[i]) === 0) return i; return PRI.length; }
    addonGroups.sort(function (a, b) { return pri(a.label) - pri(b.label); });
    addonGroups.forEach(function (g, gi) { addonState[gi] = {}; });
    renderAddons();
  }
  function itemAllowed(it) {
    if (!it.available) return false;
    var r = it.rules || {};
    var sel = current.options;
    if (r.only_when && r.only_when.length && !r.only_when.some(function (v) { return sel.indexOf(v) >= 0; })) return false;
    var ok = true;
    (r.match || []).forEach(function (m) {
      var mine = it.options.indexOf(m) >= 0;
      var theirs = sel.indexOf(m) >= 0;
      if (mine !== theirs) ok = false;
    });
    return ok;
  }
  function groupHidden(g) { return g.hideWhen.some(function (v) { return current.options.indexOf(v) >= 0; }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function renderAddons() {
    if (!addonRoot) return;
    var n = Number(addonRoot.dataset.start || 0);
    var html = '';
    addonGroups.forEach(function (g, gi) {
      n += 1;
      /* καθάρισε επιλογές που δεν ισχύουν πια */
      Object.keys(addonState[gi]).forEach(function (k) {
        var it = g.items.filter(function (x) { return String(x.id) === String(addonState[gi][k]); })[0];
        if (!it || !itemAllowed(it) || groupHidden(g)) delete addonState[gi][k];
      });
      html += '<fieldset class="krv-step" data-group="' + gi + '"><legend><span class="krv-step__num">' + n + '</span>' + esc(g.label) +
        ' <small>προαιρετικά · μπαίνει στο καλάθι μαζί</small></legend>';
      if (groupHidden(g)) {
        html += '<p class="krv-addons__note">' + esc(g.hideNote || 'Δεν χρειάζεται για αυτή την έκδοση.') + '</p></fieldset>';
        return;
      }
      if (!g.items.some(itemAllowed)) {
        var nn = g.items.map(function (x) { return (x.rules || {}).none_note; }).filter(Boolean)[0];
        html += '<p class="krv-addons__note">' + esc(nn || 'Δεν υπάρχει πρόσθετο που να ταιριάζει σε αυτή την επιλογή.') + '</p></fieldset>';
        return;
      }
      if (g.note) html += '<p class="krv-addons__note">' + esc(g.note) + '</p>';
      html += '<div class="krv-choices">';
      if (!g.multi) {
        var none = Object.keys(addonState[gi]).length === 0;
        html += '<button type="button" class="krv-choice' + (none ? ' is-on' : '') + '" data-none aria-pressed="' + none + '"><b>Χωρίς</b></button>';
      }
      g.cards.forEach(function (c, ci) {
        var allowed = c.items.filter(itemAllowed);
        var chosenId = addonState[gi][c.key];
        var chosen = c.items.filter(function (x) { return String(x.id) === String(chosenId); })[0];
        var on = !!chosen;
        var show = chosen || allowed[0] || c.items[0];
        var prices = allowed.map(function (x) { return x.price; });
        var minP = prices.length ? Math.min.apply(null, prices) : show.price;
        var priceTxt = on ? '+' + fmt(chosen.price) : (prices.length > 1 && Math.max.apply(null, prices) !== minP ? 'από +' : '+') + fmt(minP);
        html += '<div class="krv-choice krv-addon' + (on ? ' is-on' : '') + (allowed.length ? '' : ' is-off') + '">' +
          '<button type="button" class="krv-addon__main" data-card="' + ci + '"' + (allowed.length ? '' : ' disabled') + ' aria-pressed="' + on + '">' +
          (show.image ? '<img class="krv-choice__img" src="' + show.image + '" alt="" loading="lazy" width="48" height="48">' : '') +
          '<b>' + esc(c.label) + '</b><i>' + (allowed.length ? priceTxt : 'δεν ταιριάζει σε αυτή την έκδοση') + '</i></button>';
        var subs = allowed.filter(function (x) { return x.subLabel; });
        if (on && subs.length > 1) {
          html += '<div class="krv-addon__subs">';
          subs.forEach(function (x) {
            html += '<button type="button" class="krv-pill' + (x === chosen ? ' is-on' : '') + '" data-card="' + ci + '" data-variant="' + x.id + '">' + esc(x.subLabel) + '</button>';
          });
          html += '</div>';
        } else if (on && chosen.subLabel) {
          html += '<span class="krv-addon__sub">' + esc(chosen.subLabel) + '</span>';
        }
        html += '<a class="krv-choice__link" href="' + show.url + '" target="_blank" rel="noopener">Λεπτομέρειες</a></div>';
      });
      html += '</div></fieldset>';
    });
    addonRoot.innerHTML = html;
  }
  if (addonRoot) addonRoot.addEventListener('click', function (e) {
    var fs = e.target.closest('[data-group]');
    if (!fs) return;
    var gi = Number(fs.dataset.group), g = addonGroups[gi];
    if (e.target.closest('[data-none]')) { addonState[gi] = {}; }
    var pill = e.target.closest('[data-variant]');
    var main = e.target.closest('.krv-addon__main');
    if (pill) {
      var c = g.cards[Number(pill.dataset.card)];
      addonState[gi][c.key] = pill.dataset.variant;
    } else if (main) {
      var card = g.cards[Number(main.dataset.card)];
      if (addonState[gi][card.key]) { delete addonState[gi][card.key]; }
      else {
        var first = card.items.filter(itemAllowed)[0];
        if (!first) return;
        if (!g.multi) addonState[gi] = {};
        addonState[gi][card.key] = String(first.id);
      }
    } else if (!e.target.closest('[data-none]')) return;
    renderAddons();
    updateTotal();
  });
  function selectedAddons() {
    var out = [];
    addonGroups.forEach(function (g, gi) {
      Object.keys(addonState[gi]).forEach(function (k) {
        var it = g.items.filter(function (x) { return String(x.id) === String(addonState[gi][k]); })[0];
        if (it) out.push({ id: it.id, price: it.price, title: it.cardLabel + (it.subLabel ? ' (' + it.subLabel + ')' : '') });
      });
    });
    return out;
  }

  /* ---- σύνολο ---- */
  function qty() { var q = parseInt(qtyInput.value, 10); return q > 0 ? q : 1; }
  function updateTotal() {
    var adds = selectedAddons();
    var q = qty();
    var total = current.price * q;
    adds.forEach(function (a) { total += a.price * q; });
    root.querySelector('[data-krv-price]').textContent = fmt(total);
    root.querySelector('[data-krv-net]').textContent = fmt(Math.round(total / (1 + data.vat / 100)));
    var bd = root.querySelector('[data-krv-breakdown]');
    if (adds.length || q > 1) {
      var parts = [(q > 1 ? q + ' × ' : '') + 'προϊόν ' + fmt(current.price)];
      adds.forEach(function (a) { parts.push(a.title + ' ' + fmt(a.price)); });
      bd.textContent = parts.join(' + ');
      bd.hidden = false;
    } else bd.hidden = true;
    var bp = document.querySelector('[data-krv-bar-price]');
    if (bp) bp.textContent = fmt(total);
  }

  function setVariant(v) {
    current = v;
    idInput.value = v.id;
    var sum = root.querySelector('[data-krv-summary]');
    if (sum && optionSets.length) sum.textContent = v.title;
    var skuWrap = root.querySelector('[data-krv-sku]');
    if (skuWrap) { skuWrap.hidden = !v.sku; root.querySelector('[data-krv-sku-val]').textContent = v.sku || ''; }
    var stock = root.querySelector('[data-krv-stock]');
    stock.textContent = v.available ? 'Διαθέσιμο' : 'Μη διαθέσιμο';
    stock.classList.toggle('is-out', !v.available);
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Προσθήκη στο καλάθι' : 'Μη διαθέσιμο';
    var barBtn = document.querySelector('[data-krv-bar-add]');
    if (barBtn) barBtn.disabled = !v.available;
    if (v.media) showMedia(String(v.media));
    /* κουμπί «Ζήτα προσφορά»: η λίστα προσφοράς παίρνει την έκδοση που διάλεξε ο πελάτης */
    var qb = form.querySelector('[data-krv-quote]');
    if (qb) {
      var base = qb.dataset.productTitle.replace(/ \([^()]*\)$/, '');
      qb.dataset.productTitle = base + (optionSets.length ? ' (' + v.title + ')' : '');
      qb.dataset.productPrice = fmt(v.price);
      var path = qb.dataset.productUrl.split('?')[0];
      qb.dataset.productUrl = path + '?variant=' + v.id;
      qb.dataset.productHandle = qb.dataset.productHandle.split('?')[0] + '?variant=' + v.id;
      if (v.media) { var th = root.querySelector('.krv-pp__thumb[data-media-id="' + v.media + '"] img'); if (th) qb.dataset.productImage = th.currentSrc || th.src; }
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
    refreshChoices();
    renderAddons();
    updateTotal();
  }

  /* ---- ποσότητα ---- */
  form.querySelectorAll('[data-krv-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyInput.value = Math.max(1, qty() + Number(b.dataset.krvQty));
      updateTotal();
    });
  });
  qtyInput.addEventListener('input', updateTotal);

  /* ---- φωτογραφίες ---- */
  var mainImg = root.querySelector('.krv-pp__img');
  function showMedia(id) {
    var t = root.querySelector('.krv-pp__thumb[data-media-id="' + id + '"]');
    if (!t || !mainImg) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = t.dataset.src;
    mainImg.setAttribute('srcset', t.dataset.srcset);
    root.querySelectorAll('.krv-pp__thumb').forEach(function (x) {
      x.classList.toggle('is-on', x === t);
      if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
    });
  }
  root.querySelectorAll('.krv-pp__thumb[data-media-id]').forEach(function (t) {
    t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
  });
  var lb = document.querySelector('[data-krv-lightbox]');
  var zoom = root.querySelector('[data-krv-zoom]');
  if (lb && zoom && lb.showModal) {
    zoom.addEventListener('click', function () {
      var on = root.querySelector('.krv-pp__thumb.is-on');
      lb.querySelector('[data-krv-lb-img]').src = on ? on.dataset.src : mainImg.currentSrc || mainImg.src;
      lb.showModal();
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-krv-lb-close')) lb.close(); });
  }

  /* ---- καλάθι ---- */
  function addToCart(btn) {
    errEl.hidden = true;
    var q = qty();
    var items = [{ id: Number(idInput.value), quantity: q }];
    selectedAddons().forEach(function (a) { items.push({ id: a.id, quantity: q }); });
    if (!window.krvAddToCart) { form.submit(); return; }
    window.krvAddToCart(items, btn);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(addBtn); });
  var barAdd = document.querySelector('[data-krv-bar-add]');
  if (barAdd) barAdd.addEventListener('click', function () { addToCart(barAdd); });

  /* ---- μπάρα στο κινητό ---- */
  if (bar && 'IntersectionObserver' in window) {
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
      bar.classList.toggle('is-shown', !vis);
    });
    io.observe(addBtn);
  }

  /* ---- προτάσεις ---- */
  root.querySelectorAll('[data-krv-recs]').forEach(function (box) {
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.shopify-section');
      var content = inner ? inner.innerHTML.trim() : '';
      if (content && inner.querySelector('h2')) { box.innerHTML = content; box.hidden = false; }
    }).catch(function () {});
  });

  refreshChoices();
  updateTotal();
})();
